var _path, _circle;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNotificationPending({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 24,
    viewBox: "0 0 22 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.7277 9.47595C16.7277 10.8575 17.0929 11.6718 17.8964 12.6101C18.5054 13.3014 18.7 14.1889 18.7 15.1516C18.7 16.1132 18.384 17.0261 17.751 17.7673C16.9223 18.6558 15.7537 19.223 14.5609 19.3216C12.8325 19.469 11.103 19.5931 9.35053 19.5931C7.59696 19.5931 5.86854 19.5189 4.14012 19.3216C2.9463 19.223 1.77762 18.6558 0.95003 17.7673C0.317041 17.0261 0 16.1132 0 15.1516C0 14.1889 0.195691 13.3014 0.803535 12.6101C1.63222 11.6718 1.97331 10.8575 1.97331 9.47595V9.00732C1.97331 7.15717 2.43466 5.94736 3.38469 4.76304C4.79716 3.03586 7.06127 2 9.30133 2H9.39972C11.6879 2 14.0252 3.08572 15.4137 4.88713C16.3145 6.04707 16.7277 7.20591 16.7277 9.00732V9.47595ZM6.13093 21.867C6.13093 21.313 6.63929 21.0593 7.10939 20.9508C7.65929 20.8344 11.0101 20.8344 11.56 20.9508C12.0301 21.0593 12.5384 21.313 12.5384 21.867C12.5111 22.3943 12.2017 22.8619 11.7743 23.1588C11.22 23.5908 10.5695 23.8645 9.88951 23.9631C9.51343 24.0118 9.14392 24.0129 8.78096 23.9631C8.09987 23.8645 7.44938 23.5908 6.8962 23.1577C6.46765 22.8619 6.15826 22.3943 6.13093 21.867Z",
    fill: "#111111"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 18,
    cy: 4,
    r: 4,
    fill: "#FF0000"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotificationPending);
export default __webpack_public_path__ + "static/media/notification_pending.1f33c63d4b00e8c98f73ca0a26c5a45c.svg";
export { ForwardRef as ReactComponent };